const SET_PODCAST_NAME = 'preDistributionModalScreen/SET_PODCAST_NAME';
const SET_PODCAST_LANGUAGE = 'preDistributionModalScreen/SET_PODCAST_LANGUAGE';
const SET_PODCAST_DESCRIPTION =
  'preDistributionModalScreen/SET_PODCAST_DESCRIPTION';
const SET_PODCAST_ITUNES_CATEGORY =
  'preDistributionModalScreen/SET_PODCAST_ITUNES_CATEGORY';
const SET_SCENE = 'preDistributionModalScreen/SET_SCENE';
const SET_IS_SHOWING = 'preDistributionModalScreen/SET_IS_SHOWING';

export default {
  SET_IS_SHOWING,
  SET_PODCAST_NAME,
  SET_PODCAST_DESCRIPTION,
  SET_PODCAST_ITUNES_CATEGORY,
  SET_SCENE,
  SET_PODCAST_LANGUAGE,
};
